
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppFileUpload, AppImageHolder, AppSwitch } from '@/components';
import { AppButton } from '@/components';
import { useStarterPackEdit } from '@/modules/starter/pack/model/edit';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';

export default defineComponent({
    name: ROUTE_NAME_STARTER.PACK.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder, AppSwitch },
    setup() {
        const { model, v$, actions, iapOptions } = useStarterPackEdit();

        return { v$, model, actions, iapOptions };
    }
});
